    <mat-toolbar class="mat-menu-toolbar mat-elevation-z5" id="main-toolbar" color="primary">
        <mat-progress-bar mode="indeterminate" [class.hidden]="!(global.loadingState | async)" class="loading-indicator" color="accent"></mat-progress-bar>
        <div>
            <button mat-icon-button (click)="sidenav.toggle()">
                <mat-icon matTooltip="Toggle Menu" class="toolbar-icon">menu</mat-icon>
            </button>
        </div>
    
        <h1 class="logo">DLA Access monitor</h1>
        <span class="toolbar-spacer"></span>
    
        <ng-container *ngIf="canRead('AccessMonitor.Logic.Alert')">
            <button mat-icon-button [matMenuTriggerFor]="alerts" >
                <mat-icon matTooltip="Meldingen" class="toolbar-icon" matBadge="{{  (incomingNotifications > 0) ? incomingNotifications : null }}" matBadgeColor="warn" matBadgeOverlap="true">notifications</mat-icon>
            </button>
    
            <mat-menu #alerts="matMenu" class="alerts-popup" [overlapTrigger]="false" direction="left" style="max-width: 600px;" >
                <mtp-alert-popup></mtp-alert-popup>
            </mat-menu>
        </ng-container>
    
        <button mat-icon-button [matMenuTriggerFor]="themesMenu" (menuClosed)="onThemesClosed($event)"><mat-icon>color_lens</mat-icon></button>
        <mat-menu class="themes-menu" #themesMenu="matMenu">
            <button mat-menu-item (click)="setTheme('light-theme')"><div style="background:rgb(255, 255, 255)" class="theme-swatch mat-elevation-z5"></div>Light theme</button>
            <button mat-menu-item (click)="setTheme('dark-theme')"><div style="background:rgb(122, 122, 122);" class="theme-swatch mat-elevation-z5"></div>The dark side</button>
            <button *ngIf="eeActive" mat-menu-item (click)="setTheme('easter-egg-theme')"><div style="background:#e91e63" class="theme-swatch mat-elevation-z5"></div> Kinda purple</button>
            <button *ngIf="!eeActive" class="secret-easter-egg-btn" mat-menu-item (click)="onEasterEggClicked($event)"></button>
        </mat-menu>
    
        <button mat-icon-button [matMenuTriggerFor]="userInfo">
            <mat-icon matTooltip="Account">account_circle</mat-icon>
        </button>
    
        <mat-menu #userInfo="matMenu" [overlapTrigger]="false" direction="left" style="max-width: 600px;">
            <button mat-menu-item title="Configure" routerLink="/users/detail/{{currentUser?.id}}">
                <mat-icon>settings</mat-icon><span>{{currentUser?.name}}</span>
            </button>
            <button mat-menu-item title="Log out" routerLink="/login">
                <mat-icon>exit_to_app</mat-icon><span>Log out</span>
            </button>
        </mat-menu>
    
        <div class="app-update-button-wrapper" *ngIf="global.isNewerAppVersion">
            <div class="app-update-button" title="There is a new version of the app available. Click here to reload the browser to update it."
                onclick="window.location=''">
                <mat-icon>warning</mat-icon> Update the app
            </div>
        </div>
    </mat-toolbar>
    <!-- </div> -->
    
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav class="sidenav" #sidenav  [mode]="mode" (click)="closeSideNav()">
            <mat-nav-list class="sidenav-list" dense>
                <!-- <mat-list-item routerLink="/landing" routerLinkActive="active-link" ><mat-icon>face</mat-icon><a>Visitor App</a></mat-list-item> -->
                <!-- <mat-list-item routerLink="/dashboard" routerLinkActive="active-link" ><mat-icon>home</mat-icon><a>Dashboard</a></mat-list-item>  -->
                <mat-list-item routerLink="/frontdesk" routerLinkActive="active-link" ><mat-icon>groups</mat-icon><a>Bezoekersoverzicht</a></mat-list-item>
    
                <mg-collapsible-nav-list (click)="$event.stopPropagation()" topBorderEnabled="true" icon="security" title="Autorisatie" class="sidenav-list" dense *ngIf="canRead('Mango.Authorization.Group') || canRead('Mango.Authorization.Role') || canRead('AccessMonitor.Logic.User')">
                    <mat-list-item routerLink="/authorization/groups" routerLinkActive="active-link" *ngIf="canRead('Mango.Authorization.Group')"><mat-icon>group</mat-icon><a>Groepen</a></mat-list-item>
                    <mat-list-item routerLink="/authorization/roles" routerLinkActive="active-link" *ngIf="canRead('Mango.Authorization.Role')"><mat-icon>business</mat-icon><a>Rollen</a></mat-list-item>
                    <mat-list-item routerLink="/users" routerLinkActive="active-link" *ngIf="canRead('AccessMonitor.Logic.User')"><mat-icon>account_box</mat-icon><a>Gebruikers</a></mat-list-item>
                </mg-collapsible-nav-list>
            </mat-nav-list>
        </mat-sidenav>
    
        <div class="page-content" [class.hidden]="global.isNavigationChange">
            <router-outlet></router-outlet>
        </div>
    
    </mat-sidenav-container>
    
    <div class="footer"></div>



